module.exports = __webpack_public_path__ + "img/a888@2x.b638e1c7.png";